'use strict';
var numberIsNan = require('number-is-nan');

module.exports = Number.isFinite || function (val) {
	return !(typeof val !== 'number' || numberIsNan(val) || val === Infinity || val === -Infinity);
};



//////////////////
// WEBPACK FOOTER
// ../~/is-finite/index.js
// module id = 1040
// module chunks = 0